import React, { useEffect, useState, useRef } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { toPng } from "html-to-image";
import download from "downloadjs";
import Input from '@mui/material/Input';
import QRCode from 'qrcode.react';
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Select from 'react-select'
import { APP_CONSTANTS } from "../../../utils/AppConstants";
import { displayConsoleLog, displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull } from "../../../utils/Utils";
import { config } from "../../../config";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";

const VisitorQrCode = props => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false)
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const { visitorGetConfigurationSuccess, visitorGetConfigurationError } = useSelector((state) => state.visitor)
    const svgRef = useRef(null);
    const [qrCodeUrl, setQRCodeUrl] = useState('')
    const [customMessage, setCustomMessage] = useState('')
    const [qrSize, setQrSize] = useState(256)
    const [qrImgSize, setQrImgSize] = useState({ width: 35, height: 17.5 })
    const [labelSize, setLabelSize] = useState(14)
    const [customTextSize, setCustomTextSize] = useState(28)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.VISITOR_QR_CODE, true)
            fetchBusinessList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.VISITOR_QR_CODE) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.VISITOR_QR_CODE, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedLocation)) {
            getQrCode()
        }
    }, [selectedLocation])

    useEffect(() => {
        if (isLoggedInUserEmployee(user) === true && !isNull(employeeSelectedBusiness) && !isNull(employeeSelectedLocation)) {
            getQrCode()
        }
    }, [employeeSelectedBusiness, employeeSelectedLocation])

    const getQrCode = () => {
        setQrSize(256)
        setQrImgSize({ width: 35, height: 17.5 })
        setLabelSize(14)
        setCustomTextSize(28)
        let businessId = isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness
        let locationId = isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
        let url = `${config.visitorFormUrl}?businessId=${businessId}&locationId=${locationId}`
        console.log(url)
        setQRCodeUrl(url)
        setCustomMessage('')
    }

    const downloadQR = () => {
        const width = svgRef.current.offsetWidth;
        toPng(svgRef.current, { width })
            .then(function (dataUrl) {
                download(dataUrl, "qr-code.png");
            })
            .catch(function (error) {
                displayErrorToast('Something went wrong! Please try again.')
                console.error("oops, something went wrong!", error);
            });
    }

    useEffect(() => {
        if (qrSize < 38) {
            displayErrorToast('QR Code size cannot be less than 38 pixels')
        }
        let newQrSize = qrSize < 38 ? 38 : qrSize
        let percentChange = Math.round((newQrSize - 38) / 38)
        let newWidth = 5 + (5 * percentChange)
        let newHeight = 2.5 + (2.5 * percentChange)
        let newLabelSize = 4 + (4 * percentChange)
        let newCustomTextSize = 8 + (8 * percentChange)
        displayConsoleLog('-----------------------------')
        displayConsoleLog('qrSize', qrSize)
        displayConsoleLog('newWidth', newWidth)
        displayConsoleLog('newHeight', newHeight)
        displayConsoleLog('newLabelSize', newLabelSize / 2)
        displayConsoleLog('newCustomTextSize', newCustomTextSize / 2)
        setQrImgSize({ width: newWidth, height: newHeight })
        setLabelSize(newLabelSize / 2)
        setCustomTextSize(newCustomTextSize / 2)
    }, [qrSize])

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Visitor QR' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                <CommonFormBorder>
                    <div id="qrCode" className="qr-container" ref={svgRef}>
                        <div className="cqc-qr-container">
                            <QRCode value={qrCodeUrl} size={qrSize < 38 ? 38 : qrSize}
                                renderAs='svg'
                            />
                            <div className="cqc-powered-label" style={{ fontSize: labelSize }}>Powered By Togethra</div>
                            <div className="qr-code-footer">
                                <div className="qr-footer-text" style={{ fontSize: customTextSize }}>{customMessage}</div>
                            </div>
                        </div>
                    </div>
                    <CommonInputFloatFull
                        onChange={t => setQrSize(t.target.value)}
                        placeholder='Desired QR Code Size (In pixels)'
                        type='number'
                        value={qrSize}
                        isSubtext={true}
                        subText='Minimum size should be 38px (1cm)' />
                    <ButtonRow>
                        <CommonButton label='Download'
                            onClick={() => { downloadQR() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default VisitorQrCode